import o from"styled-components";import{theme as i}from"../../../theme.js";const t=o.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: ${i.spacing*4}px;
`,e=o.div`
  width: 100%;
  > img {
    border-radius: ${i.radius}px;
    aspect-ratio: 16/9;
    width: 100%;
    display: block;
    object-fit: cover;
  }
`,r=o.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*2}px;
  justify-content: center;
  > h3 {
    font-size: 20px;
    margin: 0;
    line-height: 24px;
    color: ${i.colors.gray[900]};
  }
`,n=o.h3`
  font-size: 20px;
  margin: 0;
  line-height: 24px;
  color: ${i.colors.gray[900]};
`;export{t as Container,r as ContentContainer,e as PictureContainer,n as Title};
